import type { AdminUser } from './types';

/**
 * "Son giren kullanıcı" ipucu — oturum kapansa bile kalıcı olur.
 *
 * Zustand auth store (`emlak-cms.auth`) çıkışta temizlendiği için login
 * ekranında "tekrar hoş geldiniz" deneyimi sunmak üzere ad/e-posta/avatar
 * bilgisini ayrı bir anahtarda saklarız. Token gibi hassas veri TUTULMAZ.
 */
const KEY = 'emlak-cms.last-user';

export interface LastUser {
  email: string;
  fullName: string;
  avatarUrl?: string;
}

export function readLastUser(): LastUser | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<LastUser>;
    if (!parsed?.email || !parsed?.fullName) return null;
    return {
      email: parsed.email,
      fullName: parsed.fullName,
      avatarUrl: parsed.avatarUrl,
    };
  } catch {
    return null;
  }
}

export function writeLastUser(user: Pick<AdminUser, 'email' | 'fullName' | 'avatarUrl'>): void {
  try {
    if (!user.email || !user.fullName) return;
    localStorage.setItem(
      KEY,
      JSON.stringify({ email: user.email, fullName: user.fullName, avatarUrl: user.avatarUrl }),
    );
  } catch {
    /* storage dolu / engelli — sessizce yoksay */
  }
}

export function clearLastUser(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* yoksay */
  }
}
